// extracted by mini-css-extract-plugin
export default {"spacer":"styles_spacer__VmHLl"};